import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';


const modal_style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 700,
    height: 600,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4
};

const OrderModal = props => {

    const { row } = props;

    let units = '';

    let amenities_title = 'Amenities: ';
    if (props.row.amenity_name === 'Union'){
        Array.from(row.row.intersections).map((element, i) => (units += `  ${element }\n`));
        props.row.selectedAmenities.map(e => {
            amenities_title += `${e } `;

            return amenities_title;
        });
    }
    else {
        amenities_title = `Amenity: ${ row.amenity_name}`;
        Array.from(row.row[row.amenity_name]).map((element, i) => (units += `  ${element }\n`));
    }

    return (

        <Box sx={modal_style}>
            <p>
                <Typography variant='h4' component='h4'>
                    {row.property_name}
                </Typography>
            </p>
            <p>
                <Typography variant='h5' component='h5'>
                    {amenities_title}
                </Typography>
            </p>
            <p>
                <Typography variant='h5' component='h5'>
            Total: {row.value} Apartments
                </Typography>
            </p>
            <br/>
            <TextField
                label='Units'
                multiline
                rows={16}
                value={units}
            />
        </Box>
    );
};
export default OrderModal;
